// extracted by mini-css-extract-plugin
export default {"text":"FamilyAfterPurchaseModal__text--2Z2_7"};